import React from "react";
import { AttachmentListItem } from "components/Attachments/AttachmentListItem";
import { styled } from "@mui/material/styles";
import List from "@mui/material/List";
import { IAttachment } from "components/Attachments/IAttachment";
import { v4 as uuidV4 } from "uuid";

export interface AttachmentListProps {
  attachments: IAttachment[];
  onAttachmentSelected?: (attachment: IAttachment, selected: boolean) => void;
  style?: React.CSSProperties;
}

/**
 * Takes a list of attachments and displays them
 * @param attachments the list of attachments to display
 */
export const AttachmentList = ({
  attachments,
  onAttachmentSelected
}: AttachmentListProps): JSX.Element => {
  return (
    <>
      <StyledFileList role="list" aria-label="Attachment List">
        {attachments?.map(attachment => (
          <AttachmentListItem
            key={attachment.id || uuidV4()}
            attachment={attachment}
            isInitiallySelected={false}
            onSelected={
              onAttachmentSelected
                ? selected => onAttachmentSelected(attachment, selected)
                : undefined
            }
          />
        ))}
      </StyledFileList>
    </>
  );
};

const StyledFileList = styled(List)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: 0;
  ...style;
`;
